<template>
    <el-card>
        <el-tabs v-model="activeName">
            <el-tab-pane label="经纪人/合伙人" name="first">
                <distributor-manager></distributor-manager>
            </el-tab-pane>
                <!--<el-tab-pane v-permissions="dealerApplyRecordPersion" label="合伙人申请"    name="second">
                    <distributor-apply></distributor-apply>
                </el-tab-pane>-->
                <el-tab-pane v-permissions="'dealerSetPersion'" label="招募设置" name="third">
                    <distributor-setting></distributor-setting>
                </el-tab-pane>

        </el-tabs>

    </el-card>
</template>
<script>
import DistributorManager from '@/pages/vipCard/distributorManager/children/DistributorManager'
import DistributorApply from '@/pages/vipCard/distributorManager/children/DistributorApply'
import DistributorSetting from '@/pages/vipCard/distributorManager/children/DistributorSetting'
export default {
  components: { DistributorSetting, DistributorApply, DistributorManager },
  data () {
    return {
      activeName: 'first'
    }
  }
}
</script>
